var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export function linearScale(domain, range) {
    var _a = __read(domain, 2), d0 = _a[0], d1 = _a[1];
    var _b = __read(range, 2), r0 = _b[0], r1 = _b[1];
    var span = d1 - d0 || 1;
    return function (v) { return r0 + ((v - d0) / span) * (r1 - r0); };
}
export function bandScale(count, range, gap) {
    if (gap === void 0) { gap = 0.2; }
    var step = range / Math.max(count, 1);
    var bandwidth = step * (1 - gap);
    return function (i) { return i * step + (step - bandwidth) / 2; };
}
export function bandWidth(count, range, gap) {
    if (gap === void 0) { gap = 0.2; }
    var step = range / Math.max(count, 1);
    return step * (1 - gap);
}
export function logScale(domain, range) {
    var _a = __read(domain, 2), d0 = _a[0], d1 = _a[1];
    var _b = __read(range, 2), r0 = _b[0], r1 = _b[1];
    var log0 = Math.log(Math.max(d0, 1e-6));
    var log1 = Math.log(Math.max(d1, 1e-6));
    var span = log1 - log0 || 1;
    return function (v) { return r0 + ((Math.log(Math.max(v, 1e-6)) - log0) / span) * (r1 - r0); };
}
export function polarToXY(cx, cy, r, angle) {
    return [cx + r * Math.cos(angle), cy + r * Math.sin(angle)];
}
